import NavMenu from './navMenu.component';

export default NavMenu;